import SelectBox, { Item, SelectBoxProps } from '@/components/select/SelectBox';
import { languages as supportedLanguages } from '@/config';
import { Language } from '@/models/Language';

type LanguageSelectBoxProps<T extends Item> = SelectBoxProps<T> & {
  languages?: Language[];
};

export interface LanguageItem {
  id: string;
  name: string;
  flag: string;
  disabled?: boolean;
}

const LanguageSelectBox = (props: LanguageSelectBoxProps<LanguageItem>) => {
  const {
    label = 'Language:',
    placeholder = 'Select language',
    languages = supportedLanguages,
  } = props;

  const listLanguages = (): Promise<LanguageItem[]> => {
    return new Promise((resolve) => {
      const items: LanguageItem[] = languages.map((language: Language) => ({
        id: language.code,
        name: language.name,
        flag: language.flag,
        disabled: language.isSupported === false,
      }));

      resolve(items);
    });
  };

  return (
    <SelectBox<LanguageItem>
      {...props}
      name="language"
      label={label}
      placeholder={placeholder}
      queryFn={listLanguages}
      itemRender={(item: LanguageItem, selected?: boolean) => (
        <div className="flex items-center">
          <img src={item.flag} alt={item.name} className="w-6 h-4 mr-2" />
          <span
            className={`${selected ? 'font-semibold' : 'font-normal'} block truncate ${
              item.disabled ? 'text-gray-500' : ''
            }`}
          >
            {item.name}
          </span>
        </div>
      )}
    />
  );
};

export default LanguageSelectBox;
